import {
  addUserType,
  AddUserTypeParams,
  updateUserType,
  UpdateUserTypeParams,
  listUserType,
  addRoles,
  AddRolesParams,
  updateRoles,
  UpdateRolesParams,
  deleteRoles,
  DeleteRolesParams,
  listRoles,
  addPermission,
  AddPermissionParams,
  updatePermission,
  UpdatePermissionParams,
  deletePermission,
  DeletePermissionParams,
  listPermissions,
  addRolePermission,
  AddRolePermissionParams,
  listRolePermission,
  deleteRolePermission,
  addNewAdminUser,
  AddNewAdminUserParams,
  listAdminUser,
  ListAdminUserParams,
  addUserRole,
  AddUserRoleParams,
  listUserRole,
  deleteUserRole,
  addApplication,
  AddApplicationParams,
  listApplications,
  addMenu,
  AddMenuParams,
  updateMenu,
  UpdateMenuParams,
  listMenus,
  ListMenusParams,
  deleteMenu,
  addModule,
  AddModuleParams,
  listModules,
  deleteModule,
  addTask,
  AddTaskParams,
  updateTask,
  UpdateTaskParams,
  listTasks,
  deleteTask,
  addRoleTask,
  AddRoleTaskParams,
  listRoleTask,
  ListRoleTaskParams,
  deleteRoleTask,
  addMenuPermission,
  AddMenuPermissionParams,
  listMenuPermission,
  ListMenuPermissionParams,
  deleteMenuPermission,
  addRoleMenu,
  AddRoleMenuParams,
  listRoleMenu,
  ListRoleMenuParams,
  deleteRoleMenu,
  listAllUserMenu,
} from "services/rbacService";

import {
  fetchUserTypes,
  fetchRoles,
  fetchPermissions,
  fetchRolePermissions,
  fetchAdminUsers,
  fetchUserRoles,
  fetchApplications,
  fetchMenus,
  fetchModules,
  fetchTasks,
  fetchRoleTasks,
  fetchMenuPermissions,
  fetchRoleMenus,
  fetchUserMenus,
  setRbacLoader,
  rbacSuccessMsg,
  rbacErrorMsg,
} from "./reducer";

export const addUserTypeThunk = (data: AddUserTypeParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await addUserType(data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Usertype has been saved successfully",
          id: response?.data || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to add user type",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while adding user type";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const updateUserTypeThunk = (usertypeid: number, data: UpdateUserTypeParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await updateUserType(usertypeid, data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Usertype has been updated successfully",
          id: usertypeid || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to update user type",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while updating user type";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const fetchUserTypesThunk = () => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await listUserType();

    if (response?.success && response?.data) {
      const userTypes = Array.isArray(response.data)
        ? response.data
        : [response.data];

      dispatch(fetchUserTypes(userTypes));
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to fetch user types",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      rbacErrorMsg({
        message: error?.message || "Error while fetching user types",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const addRolesThunk = (data: AddRolesParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await addRoles(data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Role has been saved successfully",
          id: response?.data || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to add role",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while adding role";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const updateRolesThunk = (roleid: number, data: UpdateRolesParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await updateRoles(roleid, data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Role has been updated successfully",
          id: roleid || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to update role",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while updating role";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const deleteRolesThunk = (roleid: number, data: DeleteRolesParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await deleteRoles(roleid, data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Role has been deleted successfully",
          id: roleid || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to delete role",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while deleting role";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const fetchRolesThunk = () => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await listRoles();

    if (response?.success && response?.data) {
      const roles = Array.isArray(response.data)
        ? response.data
        : [response.data];

      dispatch(fetchRoles(roles));
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to fetch roles",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      rbacErrorMsg({
        message: error?.message || "Error while fetching roles",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const addPermissionThunk = (data: AddPermissionParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await addPermission(data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Permission has been saved successfully",
          id: response?.data || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to add permission",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while adding permission";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const updatePermissionThunk = (permissionid: number, data: UpdatePermissionParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await updatePermission(permissionid, data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Permission has been updated successfully",
          id: permissionid || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to update permission",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while updating permission";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const deletePermissionThunk = (permissionid: number, data: DeletePermissionParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await deletePermission(permissionid, data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Permission has been deleted successfully",
          id: permissionid || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to delete permission",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while deleting permission";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const fetchPermissionsThunk = () => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await listPermissions();

    if (response?.success && response?.data) {
      const permissions = Array.isArray(response.data)
        ? response.data
        : [response.data];

      dispatch(fetchPermissions(permissions));
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to fetch permissions",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      rbacErrorMsg({
        message: error?.message || "Error while fetching permissions",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const addRolePermissionThunk = (data: AddRolePermissionParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await addRolePermission(data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Role permission has been saved successfully",
          id: response?.data || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to add role permission",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while adding role permission";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const fetchRolePermissionsThunk = () => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await listRolePermission();

    if (response?.success && response?.data) {
      const rolePermissions = Array.isArray(response.data)
        ? response.data
        : [response.data];

      dispatch(fetchRolePermissions(rolePermissions));
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to fetch role permissions",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      rbacErrorMsg({
        message: error?.message || "Error while fetching role permissions",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const deleteRolePermissionThunk = (rolepermissionid: number) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await deleteRolePermission(rolepermissionid);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Role permission has been deleted successfully",
          id: rolepermissionid || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to delete role permission",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while deleting role permission";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const addNewAdminUserThunk = (data: AddNewAdminUserParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await addNewAdminUser(data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Admin user has been added successfully",
          id: response?.data || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to add admin user",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while adding admin user";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const listAdminUserThunk = (data: ListAdminUserParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await listAdminUser(data);

    if (response?.success && response?.data?.data) {
      dispatch(
        fetchAdminUsers({
          users: response.data.data.users || [],
          pagination: response.data.data.pagination || null,
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to fetch admin users",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    dispatch(
      rbacErrorMsg({
        message: error?.message || "Error while fetching admin users",
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: error?.message || "Error while fetching admin users",
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const addUserRoleThunk = (data: AddUserRoleParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await addUserRole(data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "User role has been saved successfully",
          id: response?.data || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to add user role",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while adding user role";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const fetchUserRolesThunk = (usermaster_id: number) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await listUserRole(usermaster_id);

    if (response?.success && response?.data) {
      const userRoles = Array.isArray(response.data)
        ? response.data
        : [response.data];

      dispatch(fetchUserRoles(userRoles));
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to fetch user roles",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      rbacErrorMsg({
        message: error?.message || "Error while fetching user roles",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const deleteUserRoleThunk = (userroleid: number) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await deleteUserRole(userroleid);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "User role has been deleted successfully",
          id: userroleid || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to delete user role",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while deleting user role";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const addApplicationThunk = (data: AddApplicationParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await addApplication(data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Application has been saved successfully",
          id: response?.data || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to add application",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while adding application";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const fetchApplicationsThunk = () => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await listApplications();

    if (response?.success && response?.data) {
      const applications = Array.isArray(response.data)
        ? response.data
        : [response.data];

      dispatch(fetchApplications(applications));
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to fetch applications",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      rbacErrorMsg({
        message: error?.message || "Error while fetching applications",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const addMenuThunk = (data: AddMenuParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await addMenu(data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Menu has been saved successfully",
          id: response?.data || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to add menu",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while adding menu";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const updateMenuThunk = (menuid: number, data: UpdateMenuParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await updateMenu(menuid, data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Menu has been updated successfully",
          id: menuid || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to update menu",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while updating menu";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const fetchMenusThunk = (data: ListMenusParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await listMenus(data);

    if (response?.success && response?.data) {
      const menus = Array.isArray(response.data)
        ? response.data
        : [response.data];

      dispatch(fetchMenus(menus));
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to fetch menus",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Error while fetching menus";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const deleteMenuThunk = (menuid: number) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await deleteMenu(menuid);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Menu has been deleted successfully",
          id: menuid || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to delete menu",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while deleting menu";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const addModuleThunk = (data: AddModuleParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await addModule(data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Module has been saved successfully",
          id: response?.data || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to add module",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while adding module";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const fetchModulesThunk = (applicationid: number) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await listModules(applicationid);

    if (response?.success && response?.data) {
      const modules = Array.isArray(response.data)
        ? response.data
        : [response.data];

      dispatch(fetchModules(modules));
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to fetch modules",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      rbacErrorMsg({
        message: error?.message || "Error while fetching modules",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const deleteModuleThunk = (moduleid: number) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await deleteModule(moduleid);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Module has been deleted successfully",
          id: moduleid || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to delete module",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while deleting module";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const addTaskThunk = (data: AddTaskParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await addTask(data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Task has been saved successfully",
          id: response?.data || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to add task",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while adding task";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const updateTaskThunk = (taskid: number, data: UpdateTaskParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await updateTask(taskid, data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Task has been updated successfully",
          id: taskid || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to update task",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while updating task";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const fetchTasksThunk = () => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await listTasks();

    if (response?.success && response?.data) {
      const tasks = Array.isArray(response.data)
        ? response.data
        : [response.data];

      dispatch(fetchTasks(tasks));
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to fetch tasks",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      rbacErrorMsg({
        message: error?.message || "Error while fetching tasks",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const deleteTaskThunk = (taskid: number) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await deleteTask(taskid);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Task has been deleted successfully",
          id: taskid || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to delete task",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while deleting task";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const addRoleTaskThunk = (data: AddRoleTaskParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await addRoleTask(data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Role task has been saved successfully",
          id: response?.data || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to add role task",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while adding role task";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const fetchRoleTasksThunk = (data: ListRoleTaskParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await listRoleTask(data);

    if (response?.success && response?.data) {
      const roleTasks = Array.isArray(response.data)
        ? response.data
        : [response.data];

      dispatch(fetchRoleTasks(roleTasks));
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to fetch role tasks",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      rbacErrorMsg({
        message: error?.message || "Error while fetching role tasks",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const deleteRoleTaskThunk = (roletaskid: number) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await deleteRoleTask(roletaskid);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Role task has been deleted successfully",
          id: roletaskid || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to delete role task",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while deleting role task";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const addMenuPermissionThunk = (data: AddMenuPermissionParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await addMenuPermission(data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Menu permission has been saved successfully",
          id: response?.data || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to add menu permission",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while adding menu permission";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const fetchMenuPermissionsThunk = (data: ListMenuPermissionParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await listMenuPermission(data);

    if (response?.success && response?.data) {
      const menuPermissions = Array.isArray(response.data)
        ? response.data
        : [response.data];

      dispatch(fetchMenuPermissions(menuPermissions));
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to fetch menu permissions",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      rbacErrorMsg({
        message: error?.message || "Error while fetching menu permissions",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const deleteMenuPermissionThunk = (menupermissionid: number) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await deleteMenuPermission(menupermissionid);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Menu permission has been deleted successfully",
          id: menupermissionid || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to delete menu permission",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while deleting menu permission";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const addRoleMenuThunk = (data: AddRoleMenuParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await addRoleMenu(data);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Role Menu has been saved successfully",
          id: response?.data || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to add role menu",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while adding role menu";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const fetchRoleMenusThunk = (data: ListRoleMenuParams) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await listRoleMenu(data);

    if (response?.success && response?.data) {
      // Map API's 'id' to 'role_menuid' for consistency
      const roleMenus = Array.isArray(response.data)
        ? response.data.map((item) => ({
            ...item,
            role_menuid: item.id,
          }))
        : [];

      dispatch(fetchRoleMenus(roleMenus));
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to fetch role menus",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      rbacErrorMsg({
        message: error?.message || "Error while fetching role menus",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const deleteRoleMenuThunk = (role_menuid: number) => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await deleteRoleMenu(role_menuid);

    if (response?.success) {
      dispatch(
        rbacSuccessMsg({
          message: response?.message || "Role Menu has been deleted successfully",
          id: role_menuid || Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to delete role menu",
          id: Date.now(),
        })
      );
      return response;
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong while deleting role menu";
    dispatch(
      rbacErrorMsg({
        message: errorMessage,
        id: Date.now(),
      })
    );
    return {
      success: false,
      message: errorMessage,
    };
  } finally {
    dispatch(setRbacLoader(false));
  }
};

export const fetchAllUserMenusThunk = () => async (dispatch: any) => {
  dispatch(setRbacLoader(true));

  try {
    const response = await listAllUserMenu();

    if (response?.success && response?.data) {
      const userMenus = Array.isArray(response.data)
        ? response.data
        : [];

      dispatch(fetchUserMenus(userMenus));
    } else {
      dispatch(
        rbacErrorMsg({
          message: response?.message || "Failed to fetch user menus",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      rbacErrorMsg({
        message: error?.message || "Error while fetching user menus",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setRbacLoader(false));
  }
};

